module.exports = __webpack_public_path__ + "img/dotted_circle.fd215399.svg";